import Banner from "@/components/landing/helpCenter/Banner";
import BrowseByCategory from "@/components/landing/helpCenter/BrowseByCategory";
import Faqs from "@/components/landing/helpCenter/Faqs";
import NeedToContact from "@/components/landing/helpCenter/NeedToContact";

export default function HelpCenter() {
  return (
    <>
      {/* Banner section */}
      <Banner />

      {/* Browse By Category section */}
      <BrowseByCategory />

      {/* Faqs section */}
      <Faqs />

      {/* Need To Contact section */}
      <NeedToContact />
    </>
  );
}
